import React, { useEffect, useMemo } from 'react'
import { useField, useFormikContext } from 'formik'

import RadioGroup from 'devextreme-react/radio-group'

// import { useTranslation } from 'react-i18next'

import './index.scss'
import { FormErrors } from 'components/forms/form-errors'


export const RadioInput = ({label, opts, readOnly = false, valueExpr = 'value', displayExpr = 'name', showDataBeforeSearch = true, minSearchLength = 3, layout = 'horizontal', ...props}: any) => {
    const { setFieldValue } = useFormikContext()
    const [field, meta] = useField(props)
    // const { t } = useTranslation()

    const handleChange = (e: any) => {
        setFieldValue(field.name, e.value, true)
    }

    const optsValues = useMemo(() => opts.map((x: any) => x.value), [opts])

    useEffect(() => {
        if (field.value === null) { return }
        if (!optsValues.includes(field.value)) {
            setFieldValue(field.name, null)
        }
    }, [optsValues, field.value, field.name, setFieldValue])

    return (
        <div className='rb-item mb-1'>
            <div>
                <label htmlFor={props.id || field.name} className='dx-field-label'>{label}</label>
                <RadioGroup
                    dataSource={opts}
                    name={field.name}
                    value={field.value}
                    onValueChanged={handleChange}
                    className='dx-field-input'
                    isValid={!(meta.touched && meta.error)}
                    valueExpr={valueExpr}
                    displayExpr={displayExpr}
                    disabled={readOnly}
                    layout={layout}
                />
            </div>
            <FormErrors meta={meta} />
        </div>
    )
}
